import { render } from "./InputEntitySector.vue?vue&type=template&id=3856eb17"
import script from "./InputEntitySector.vue?vue&type=script&lang=js"
export * from "./InputEntitySector.vue?vue&type=script&lang=js"
script.render = render

export default script